import {Utility} from "./utility";
import {Features} from "./api";
import {ANIMATIONS, BIND, IF, REFLECT} from "./directives";
import {Reactivity} from "./reactivity";
import {errorHandler} from "../errors/errorHandler";

export const TemplateSyntax = {

	Events: [
		'mouseover',
		'mouseout',
		'keydown',
		'load',
		'animationend',
		'animationiteration',
		'animationstart',
		'blur',
		'canplay',
		'change',
		'click',
		'copy',
		'paste',
		'cut',
		'dblclick',
		'focus',
		'input',
		'keydown',
		'keypress',
		'keyup',
		'mousedown',
		'mouseenter',
		'mouseleave',
		'mousemove',
		'mouseover',
		'mouseout',
		'mouseup',
		'mousewheel',
		'pause',
		'play',
		'playing',
		'scroll',
		'submit',
		'wheel',
	],

	/**
	 * Detects elements that have an event attached to them and applies it accordingly
	 * @param {Document} Document
	 * @constructor
	 */
	OnEvents: (Document) => {
		TemplateSyntax.Events.forEach(Event => {
			Document.querySelectorAll(`[on${Event}]`).forEach(element => {
				// get function or script you are trying to run
				const onclickValue = element.attributes[`on${Event}`].value;

				// remove the attribute and replace with custom one
				element.removeAttribute(`on${Event}`);
				element.setAttribute(`js-${Event}`, onclickValue);

				// execute a script where 'this' is the VM
				if (onclickValue.indexOf('#') !== -1) {
					const scriptRaw = onclickValue.replace("#", "").replace(/this/g, '$this');
					const parsedScript = scriptRaw
											.replace(/\\/g, "\\\\")
											// .replace(/'/g, "\\'")
											.replace(/"/g, "\\\"")
											.replace(/\n/g, "\\\n")
											.replace(/\r/g, "\\\r")
											.replace(/x00/g, "\\\x00")
											.replace(/x1a/g, "\\\x1a");

					element[`on${Event}`] = () => {
						// run the script
						eval(`(${parsedScript})`);
					}
				}

				// run a method either in your VM or on the WINDOW object
				else {
					let paramsRaw;
					let params = [];


					// get the raw params data
					if (onclickValue.indexOf('(') !== -1) {
						paramsRaw = onclickValue.split('(')[1]
							.replace('(', '')
							.replace(')', '')
							.replace(/'/g, '');

						// build up valid param data
						if (paramsRaw.indexOf("{") !== -1) {
							errorHandler.New({
								label: 'Syntax Error',
								message: `Raw Object passed to function (${onclickValue.split('(')[0]}), please rather create a variable and pass that to the method`
							});
						}
						else {
							const split = paramsRaw.split(',');
							if (split[0] !== "") params = Utility.formatFunctionParams(split);
						}
					}

					// check  if the method passed is from the Window Object
					const isWindowMethod = Utility.getNestedProperty(window, onclickValue.split('(')[0]);

					// set the function to call
					let Function;
					if (!isWindowMethod) {
						Function = Utility.getNestedProperty(Features.VM, onclickValue.split('(')[0]);
					}
					else {
						Function = Utility.getNestedProperty(window, onclickValue.split('(')[0]);
					}

					// if a function was found to use
					if (Function) {
						// Build up params passed to function
						const RunMethod = (functionEvent) => {
							const actualParams = [];

							// loop over the valid params data and build up all params to pass to method
							params.forEach(param => {

								// if the param is a VM property
								if (param.isVMProp) actualParams.push(Utility.getNestedProperty(Features.VM, param.original));

								// if the  param is just a raw/element related param
								else {
									// trying to access the element itself
									if (param.value.indexOf('this') !== -1) {
										if (param.value.indexOf('.') !== -1) {
											const value = Utility.getNestedProperty(element, param.value.replace('this.', ''));
											actualParams.push(value);
										}
										else {
											actualParams.push(element);
										}
									}

									// any other param passed
									else {
										actualParams.push(Utility.parseFunctionParams(param));
									}
								}
							});

							actualParams.push(functionEvent);

							// call the selected function/method passing params
							Function(...actualParams);

							// check for any system errors
							// errorHandler.generateVisualErrorLog();
						};

						// assign the event to the element
						element[`on${Event}`] = RunMethod;
					}
					else {
						errorHandler.New({
							label: 'Syntax Error',
							message: `The function you are trying to call at onclick="${onclickValue}" for ELEMENT: [${element.outerHTML}] does not exist`
						});
					}
				}
			});
		});
	},

	/**
	 * Checks for any elements using the if directive and saves the element binding data
	 * @param ELEMENT
	 * @param REF
	 * @returns {boolean}
	 * @constructor
	 */
	IfDirectives: (ELEMENT, REF) => {
		let foundInterpolation = false;
		if (ELEMENT.hasAttribute(IF["@If"])) {
			let elementValue = ELEMENT.attributes[IF["@If"]].value.replace('{', '').replace('}', '');

			// build up the element binding data object
			const Binding = Reactivity.reactiveElement();
			Binding.elementReference = ELEMENT;
			Binding.elementIndex = [...ELEMENT.parentNode.children].indexOf(ELEMENT);
			Binding.elementParent = ELEMENT.parentNode;
			Binding.elementBinding = elementValue;
			Binding.reference = `ajs-${REF}`;
			Binding.bindingType = "IF";

			// make sure the value is not an expresion before checking the value type
			if (Binding.elementBinding.indexOf('#') === -1) {
				// check if the binding was defined with Def()
				if (Features.VM[Binding.elementBinding]) {
					if (Features.VM[Binding.elementBinding].isDef) Binding.isDef = true;
				}

				// check if the binding was defined with Reactive()
				if (Binding.elementBinding.indexOf('.') > -1) {
					if (Utility.getNestedProperty(Features.VM, Binding.elementBinding) !== undefined) Binding.isRct = true;
				}
			}
			else {
				Binding.expression = elementValue;
				Binding.isExpression = true;
			}

			// check for sibling element using the Else directive
			if (ELEMENT.nextElementSibling != null) {
				if (ELEMENT.nextElementSibling.hasAttribute("if-Ajf67Jy")) {
					Binding.elementSibling = ELEMENT.nextElementSibling;
				}
			}

			//* check if element already has a binding
			let check = window.$ActiveJS["DOMBoundKeys"].filter(boundKey => {
				let found = ELEMENT.getAttributeNode(boundKey);
				if (found != null) {
					return boundKey
				}
			});

			// if there are no other elements with current reference
			if (check.length == 0) {
				window.$ActiveJS["DOMBindings"].push(Binding);
				window.$ActiveJS["DOMBoundKeys"].push("qm-"+REF);
				foundInterpolation = true;
			}

			return foundInterpolation;

		}
	},

	/**
	 * Checks for any elements using the bind directive and saves the element binding data
	 * @param ELEMENT
	 * @param REF
	 * @returns {boolean}
	 * @constructor
	 */
	BindDirectives: (ELEMENT, REF) => {
		const found = [];
		let foundInterpolation = false;

		// look for all bindings in element
		Object.entries(BIND).forEach(binding => {
			if (ELEMENT.hasAttribute(binding[1])) {
				// the type of binding
				let type = binding[1].replace('bind-', '');

				// check that the binding doesn't exist
				const check = found.filter(binding => binding.type === type);

				if (check.length == 0) found.push({
					type,
					elementBinding: ELEMENT.attributes[binding[1]].value
						.replace("{", "")
						.replace("}", "")
				});
			}
		});

		if (found.length != 0) {
			// build up the element binding data object
			const Binding = Reactivity.reactiveElement();
			Binding.elementReference = ELEMENT;
			Binding.reference = `ajs-${REF}`;
			Binding.bindingType = "BIND";
			Binding.elementBindings = [];

			// checks what the binding was defined with
			const defineBindingType = (binding) => {
				const returnValue = {isDef: false, isRct: false};
				// check if the binding was defined with Def()
				if (Features.VM[binding]) {
					if (Features.VM[binding].isDef) {
						Binding.isDef = true;
						returnValue.isDef = true;
						returnValue.isRct = false;
					}
					else {
						Binding.isDef = false;
						returnValue.isDef = false;
						returnValue.isRct = false;
					}
				}

				// check if the binding was defined with Reactive()
				if (binding.indexOf('.') > -1) {
					if (Utility.getNestedProperty(Features.VM, binding) !== undefined) {
						Binding.isRct = true;
						returnValue.isDef = false;
						returnValue.isRct = true;
					}
				}

				return returnValue;
			};

			// decides how to apply two way data binding
			const decideHowToSetValue = (type, isContenteditable) => {
				if (ELEMENT[type] !== undefined) TemplateSyntax.setupTwoWayBinding(ELEMENT, type, Binding);
				else if (type === 'class') TemplateSyntax.updateBindElement(ELEMENT, type, Binding);
			};

			// stores the binding data
			const finish = () => {
				//* check if element already has a binding
				let check = window.$ActiveJS["DOMBindings"].filter(binding => {
					let found = ELEMENT.getAttributeNode(binding.bindDirectiveType);
					if (found != null) {
						// return binding
					}
				});

				// if there are no other elements with current reference
				if (check.length == 0) {
					window.$ActiveJS["DOMBindings"].push(Binding);
					window.$ActiveJS["DOMBoundKeys"].push("qm-"+REF);
					foundInterpolation = true;

					// check if the element has content editable attribute
					let isContenteditable;
					if (ELEMENT.hasAttribute('contenteditable')) {
						if (ELEMENT.attributes['contenteditable'].specified === true) isContenteditable = true;
						else isContenteditable = false;
					}
					else isContenteditable = false;

					// set binding value
					Binding.contentEditable = isContenteditable;

					if (!Binding.containsMultiBindings) {
						// decide the binding type
						decideHowToSetValue(Binding.twoWayBinding, isContenteditable);

					}
					else {
						// decide the binding type
						Binding.elementBindings.forEach(multi => {
							// decide the binding type
							decideHowToSetValue(multi.type, isContenteditable);
						});
					}

					return foundInterpolation;
				}
			};

			// check if multiple bindings where found on element
			if (found.length >= 2) {
				Binding.containsMultiBindings = true;

				// build up multi binding data
				found.forEach(_binding => {
					// choose binding type
					const type = defineBindingType(_binding.elementBinding);

					// add binding data to (multiBindingReferences)
					let insideArr = false
					Binding.elementBindings.filter(bind => {
						if (bind.bindingName === _binding) insideArr = true;
					});

					if (!insideArr) {
						Binding.elementBindings.push({
							type: _binding.type,
							bindingName: _binding.elementBinding,
							isDef: type.isDef,
							isRct: type.isRct
						});
					}
				});

				// finish setting up the binding
				return finish();
			}
			else if (found.length === 1) {
				// build up binding object
				Binding.elementBinding = found[0].elementBinding;
				Binding.twoWayBinding = found[0].type;
				Binding.containsMultiBindings = false;

				// check what the binding was defined with
				defineBindingType(Binding.elementBinding);

				// finish setting up the binding
				return finish();
			}
		}
		else {
			return;
		}

	},

	/**
	 * Checks for any elements using the animation directive and saves the element binding data
	 * @param ELEMENT
	 * @param REF
	 * @constructor
	 */
	AnimationDirectives: (ELEMENT, REF) => {
		// look through elements attributes for an animation directive
		for (let i = 0; i < ELEMENT.attributes.length; i++) {
			const attribute = ELEMENT.attributes[i];
			if (attribute.localName.indexOf('vm-animate') != -1) {
				// get the animation function name and raw options
				const animationName = attribute.localName
					.replace(/vm-animate-/g, "")
					.replace(/in-/g, "")
					.replace(/out-/g, "");

				const animationFunctionKey = animationName.charAt(0).toUpperCase() + animationName.substring(1);
				const animationOptionsRaw = attribute.value.replace("{", "").replace("}", "").split(",");

				// build up options for the animation
				const animationOptions = {};
				if (animationOptionsRaw[0] !== "") {
					animationOptionsRaw.forEach(options => {
						const rawValues = options.split(":");
						let value;
						if (isNaN(Number(rawValues[1]))) value = rawValues[1].replace(" ", "");
						else value = Number(rawValues[1]);
						animationOptions[rawValues[0].replace(" ", "")] = value
					});
				}

				// create a binding for the element
				const Binding = Reactivity.reactiveElement();
				Binding.elementReference = ELEMENT;
				Binding.animationOptions = animationOptions;
				Binding.animationFunction = animationFunctionKey;

				$ActiveJS.DOMAnimations.push(Binding);
			}
		}

	},

	/**
	 * Gets all the interpolation in elements attributes
	 * @param ELEMENT
	 * @param REF
	 * @returns {boolean}
	 */
	getAllAttributeInterpolation(ELEMENT, REF) {

		let regex = /{([^}]+)}/g;
		let rxp = regex;
		let varMatch;
		let foundInterpolation = false;

		// checks what the binding was defined with
		const defineBindingType = (Binding, attributeValue) => {
			const returnValue = {isDef: false, isRct: false};
			// check if the binding was defined with Def()
			if (Features.VM[attributeValue]) {
				if (Features.VM[attributeValue].isDef) {
					Binding.isDef = true;
					returnValue.isDef = true;
					returnValue.isRct = false;
				}
				else {
					Binding.isDef = false;
					returnValue.isDef = false;
					returnValue.isRct = false;
				}
			}

			// check if the binding was defined with Reactive()
			if (attributeValue.indexOf('.') > -1) {
				if (Utility.getNestedProperty(Features.VM, attributeValue) !== undefined) {
					Binding.isRct = true;
					returnValue.isDef = false;
					returnValue.isRct = true;
				}
			}

			return returnValue;
		};

		// finish with the element
		const finish = (Binding) => {
			//* check if element already has a binding
			let check = window.$ActiveJS["DOMBoundKeys"].filter(boundKey => {
				let found = ELEMENT.getAttributeNode(boundKey);
				if (found != null) {
					return boundKey
				}
			});

			// if there are no other elements with current reference
			if (check.length === 0) {
				window.$ActiveJS["DOMBindings"].push(Binding);
				window.$ActiveJS["DOMBoundKeys"].push(`ajs-${REF}`);
			}
		};

		// loop through the elements attributes
		Object.entries(ELEMENT.attributes).forEach(attr => {

			// build up the element binding data object
			const Binding = Reactivity.reactiveElement();
			Binding.elementReference = ELEMENT;
			Binding.reference = `ajs-${REF}`;
			Binding.bindingType = "ATTRIBUTE";
			Binding.elementBindings = [];
			Binding.rawHTML = ELEMENT.innerHTML;

			// don't look at animation directives
			let val = attr[1].localName.indexOf('on');
			if (
				(attr[1].localName.indexOf('vm-animate') == -1) &&
				(attr[1].localName.indexOf('on') == -1) &&
				(attr[1].localName.indexOf('bind-') == -1)
			) {
				// found interpolation
				let found = [];

				// look for interpolation
				while( varMatch = rxp.exec( attr[1].nodeValue ) ) {
					foundInterpolation = true;

					// make sure the element is not a container
					if (!ELEMENT.firstElementChild) {
						found.push({
							attributeName: attr[1].nodeName,
							attributeValue: varMatch[1].replace(/ /g,'')
						});
					}
				}

				// check if there are multiple bindings
				if (found.length >= 2) {
					Binding.containsMultiBindings = true;

					// build up multi binding data
					found.forEach(_binding => {
						// choose binding type
						const type = defineBindingType(Binding, _binding.attributeValue);

						// add binding data to (multiBindingReferences)
						Binding.elementBindings.push({
							isDef: type.isDef,
							isRct: type.isRct,
							rawAttribute: attr[1].nodeValue,
							bindingName: _binding.attributeValue,
							attributeName: _binding.attributeName,
						});
					});

					// finish setting up the binding
					if (foundInterpolation) finish(Binding);
				}
				else if (found.length === 1) {
					// build up binding object
					Binding.containsMultiBindings = false;
					Binding.elementBinding = found[0].attributeValue;
					Binding.attributeName = found[0].attributeName;
					Binding.attributeValue = found[0].attributeValue;

					// check what the binding was defined with
					const type = defineBindingType(Binding, Binding.elementBinding);

					// finish setting up the binding
					if (foundInterpolation) finish(Binding);
				}
			}
		});

		return foundInterpolation;

	},

	/**
	 * Gets all the interpolation in elements innerHTML
	 * @param ELEMENT
	 * @param REF
	 * @returns {boolean}
	 */
	getAllHtmlInterpolation(ELEMENT, REF) {

		let rxp = /{([^}]+)}/g;
		let varMatch;
		let found = [];
		let innerHTML = ELEMENT.innerHTML;
		let foundInterpolation = false;

		while( varMatch = rxp.exec( innerHTML ) ) {
			found.push(varMatch[1].replace(/ /g,''));
		}

		// build up the element binding data object
		const Binding = Reactivity.reactiveElement();
		Binding.elementReference = ELEMENT;
		Binding.reference = `ajs-${REF}`;
		Binding.bindingType = "HTML";
		Binding.rawHTML = ELEMENT.innerHTML;

		// checks what the binding was defined with
		const defineBindingType = (binding) => {
			const returnValue = {isDef: false, isRct: false};
			// check if the binding was defined with Def()
			if (Features.VM.hasOwnProperty(binding)) {
				if (Features.VM[binding].isDef) {
					Binding.isDef = true;
					returnValue.isDef = true;
					returnValue.isRct = false;
				}
				else {
					Binding.isDef = false;
					returnValue.isDef = false;
					returnValue.isRct = false;
				}
			}

			// check if the binding was defined with Reactive()
			if (binding.indexOf('.') > -1) {
				if (Utility.getNestedProperty(Features.VM, binding) !== undefined) {
					Binding.isRct = true;
					returnValue.isDef = false;
					returnValue.isRct = true;
				}
			}

			return returnValue;
		};

		const finish = () => {
			//* check if element already has a binding
			let check = window.$ActiveJS["DOMBoundKeys"].filter(boundKey => {
				let found = ELEMENT.getAttributeNode(boundKey);
				if (found != null) {
					return boundKey
				}
			});

			// if there is no element with the current reference
			if (check.length === 0) {
				window.$ActiveJS["DOMBindings"].push(Binding);
				window.$ActiveJS["DOMBoundKeys"].push(`ajs-${REF}`);
				foundInterpolation = true;
			}
		};

		// check if there are multiple bindings
		if (found.length >= 2) {
			Binding.containsMultiBindings = true;

			// build up multi binding data
			found.forEach(_binding => {
				// choose binding type
				const type = defineBindingType(_binding);

				// add binding data to (multiBindingReferences)
				let insideArr = false
				Binding.elementBindings.filter(bind => {
					if (bind.bindingName === _binding) insideArr = true;
				});

				if (!insideArr) {
					Binding.elementBindings.push({
						bindingName: _binding,
						isDef: type.isDef,
						isRct: type.isRct
					});
				}
			});

			// finish setting up the binding
			finish();
		}
		else if (found.length === 1) {
			// build up binding object
			Binding.elementBinding = found[0];
			Binding.containsMultiBindings = false;

			// check what the binding was defined with
			defineBindingType(Binding.elementBinding);

			// finish setting up the binding
			finish();
		}

		return foundInterpolation;

	},

	/**
	 * Will apply two way data binding to an element
	 * @param {Element} ELEMENT
	 * @param {String} bindingType
	 * @param {Object} binding
	 */
	setupTwoWayBinding: (ELEMENT, bindingType, Binding) => {
		// check type of binding
		let bindingValue;
		if (!Binding.containsMultiBindings) {
			if (Binding.isDef) bindingValue = Features.VM[Binding.elementBinding].value
			else if (Binding.isRct) bindingValue = Utility.getNestedProperty(Features.VM, Binding.elementBinding);
		}
		else {
			Binding.elementBindings.forEach(multi => {
				if (Binding.isDef) bindingValue = Features.VM[multi.bindingName].value
				else if (Binding.isRct) bindingValue = Utility.getNestedProperty(Features.VM, multi.bindingName);
			})
		}

		// setup the initial value for the element
		ELEMENT[bindingType] = bindingValue;

		// setup event for element value change
		ELEMENT.oninput = (e) => {

			if (Binding.isDef) {
				Features.VM[Binding.elementBinding].value = e.target[bindingType];
			}
			else if (Binding.isRct) {
				Utility.setNestedProperty(Features.VM, Binding.elementBinding, e.target[bindingType]);
			}
			else {
				Features.VM[Binding.elementBinding] = e.target[bindingType];
			}

		};
	},

	updateBindElement: (ELEMENT, bindingType, Binding) => {
		// check type of binding
		let bindingValue;
		if (!Binding.containsMultiBindings) {
			if (Binding.isDef) bindingValue = Features.VM[Binding.elementBinding].value
			else if (Binding.isRct) bindingValue = Utility.getNestedProperty(Features.VM, Binding.elementBinding);
		}
		else {
			Binding.elementBindings.forEach(multi => {
				if (Binding.isDef) bindingValue = Features.VM[multi.bindingName].value
				else if (Binding.isRct) bindingValue = Utility.getNestedProperty(Features.VM, multi.bindingName);
			})
		}

		// if the type is a class update element class attribute
		if (bindingType === "class") {
			const classes = bindingValue.split(" ");
			classes.forEach(className => ELEMENT.classList.add(className));
		}
	},

};